import { loadDraft, saveDraft, clearDraft } from "../../lib/draft";

/**
 * 최근 검색어.
 *
 * 이전에는 고정 문자열 세 개를 "최근 검색" 이라고 보여줬다. 그건 거짓말이다 —
 * 내가 찾은 적 없는 말이 내 기록인 척 있었다. 실제로 이 기기에서 찾은 것만 남긴다.
 *
 * 서버에 보내지 않는다. 무엇을 찾았는지는 이 기기 밖으로 나갈 이유가 없다.
 *
 * 다만 기기 밖으로 안 나간다고 **기기 안에서 아무나 봐도 되는 것은 아니다.**
 * 키에 사용자를 담지 않으면 그 기기의 모든 계정이 목록 하나를 나눠 쓴다 —
 * A 가 무엇을 찾았는지가 B 의 "최근 검색" 에 그대로 올라온다. 한 기기를
 * 나눠 쓰는 것은 이 제품에서 드문 일이 아니고, 무엇을 찾는지는 그 사람의
 * 일이다. 제보 초안과 같은 규칙을 쓴다.
 */
const MAX = 8;

const keyFor = (userId?: string | null) => `recent-searches:${userId ?? "guest"}`;

export function recentSearches(userId?: string | null): string[] {
  const v = loadDraft<string[]>(keyFor(userId));
  return Array.isArray(v) ? v.filter((s) => typeof s === "string").slice(0, MAX) : [];
}

export function rememberSearch(term: string, userId?: string | null): string[] {
  const t = term.trim();
  if (t.length < 1) return recentSearches(userId);
  /* 같은 말을 다시 찾으면 맨 앞으로 올린다 — 목록이 중복으로 차지 않게. */
  const next = [t, ...recentSearches(userId).filter((s) => s !== t)].slice(0, MAX);
  saveDraft(keyFor(userId), next);
  return next;
}

export function forgetSearches(userId?: string | null): void {
  clearDraft(keyFor(userId));
}

/**
 * 사용자별로 나누기 전에 쓰던 공용 목록을 치웁니다.
 *
 * 이제 아무도 읽지 않지만, `pruneDrafts` 는 시각이 없는 값을 건드리지 않아서
 * (배열에는 `savedAt` 이 없습니다) 그냥 두면 **앞사람 검색어가 기기에 영원히
 * 남습니다.** 읽히지 않는다고 없는 것은 아닙니다.
 */
export function forgetSharedSearches(): void {
  clearDraft("recent-searches");
}
